<template>
  <div class="forget-password">
    <div class="forget-password_title">忘记密码</div>
    <steps class="form-steps" :steps="['安全校验', '重置密码', '完成']" :value="currentStep" />
    <div class="center">
      <!-- 安全校验 -->
      <template v-if="currentStep === 1">
        <safety-check type="2" @success="safetyCheckSuccess" />
      </template>

      <!-- 重置密码 -->
      <template v-if="currentStep === 2">
        <el-form ref="form" key="modifyForm" class="modify-form" :model="form" :rules="formRules">
          <div class="tips">请为您的账号设置一个新的密码</div>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              placeholder="请设置6位数以上的密码"
              maxlength="20"
              :type="showPassword ? 'text' : 'password'"
            >
              <img slot="prefix" class="icon-lock" src="@/assets/images/icon-lock.png">
              <img
                slot="suffix"
                class="icon-toggle"
                :src="require(showPassword ? '@/assets/images/icon-eye-fill.png' : '@/assets/images/icon-close-eye.png')"
                @click="showPassword = !showPassword"
              >
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input
              v-model="form.confirmPassword"
              placeholder="请再次输入密码"
              maxlength="20"
              :type="showConfirmPassword ? 'text' : 'password'"
            >
              <img slot="prefix" class="icon-lock" src="@/assets/images/icon-lock.png">
              <img
                slot="suffix"
                class="icon-toggle"
                :src="require(showConfirmPassword ? '@/assets/images/icon-eye-fill.png' : '@/assets/images/icon-close-eye.png')"
                @click="showConfirmPassword = !showConfirmPassword"
              >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="nextStep-button" type="primary" @click="submitNewPassword">下一步</el-button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 表单结果提示 -->
      <template v-if="currentStep === 3">
        <div class="form-result">
          <img class="result-icon" src="@/assets/images/icon-success.png">
          <div class="result-desc">重置密码成功，{{ autoTime }}s后将自动返回首页</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Steps from '@/components/Steps'
import SafetyCheck from '@/components/SafetyCheck'
import { changePassword } from '@/api'
import regExp from '@/regexp'

const AUTO_RETURN_TIME = 3

let timer

export default {

  components: {
    Steps,
    SafetyCheck
  },
  data() {
    return {
      currentStep: 1,

      safetyCheck: {},

      /* 重置密码 */
      form: {
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      formRules: {
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 6,
            message: '请输入6~20位的密码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (!regExp.password.test(value)) {
                return callback(new Error('密码必须包含数字、字母、字符至少两种，且在6~20位之间'))
              }

              if (this.form.confirmPassword !== '') {
                this.$refs.form.validateField('confirmPassword')
              }

              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: '请再次输入密码',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      showPassword: false, // 是否显示密码
      showConfirmPassword: false, // 是否显示确认密码

      autoTime: AUTO_RETURN_TIME
    }
  },

  destroyed() {
    clearTimeout(timer)
  },

  methods: {
    /*
     * 安全校验通过
     */
    safetyCheckSuccess(e) {
      this.safetyCheck = e

      this.nextStep()
    },

    /*
     * 下一步操作
     */
    nextStep() {
      this.currentStep++
    },

    /*
     * 提交新的密码修改
     */
    submitNewPassword() {
      // 两次密码是否一致
      this.$refs.form.validate(valid => {
        if (valid) {
          changePassword({
            userName: this.safetyCheck.email,
            code: this.safetyCheck.code,
            pass: this.form.password
          })
            .then(res => {
              this.nextStep()
              this.autoReturnIndex()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },

    /*
     * 3秒后自动返回登录页
     */
    autoReturnIndex() {
      timer = setTimeout(() => {
        this.autoTime--

        clearTimeout(timer)
        if (this.autoTime <= 0) {
          this.$router.replace({
            name: 'login'
          })
        } else {
          this.autoReturnIndex()
        }
      }, 1000)
    }
  }
}
</script>

<style lang='scss' scoped>
.forget-password {
  min-height: 100%;
  background-color: #fff;
  padding: 20px 0 0;
  .forget-password_title {
    position: relative;
    font-size: 28px;
    color: #000;
    font-weight: bold;
    margin: 0 15%;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -22px;
      width: 8px;
      height: 26px;
      transform: translateY(-50%);
      background-color: #417ef7;
    }
  }
  .form-steps {
    margin: 47px auto 0;
  }
  .center {
    display: table;
    margin: 0 auto 50px;
  }

  /deep/ .el-input {
    font-size: 16px;
    > input {
      height: 56px;
      padding-left: 58px;
      border-radius: 6px;
    }
    .el-input__prefix {
      left: 29px;
      display: flex;
      align-items: center;
      transform: translateX(-50%);
    }
  }
  /deep/ .modify-form {
    margin: 60px 0 0;
    width: 519px;
    .el-input {
      > input {
        padding-right: 58px;
      }
    }
    .el-input__suffix {
      right: 29px;
      display: flex;
      align-items: center;
      transform: translateX(50%);
      .el-input__suffix-inner {
        display: flex;
        align-items: center;
      }
    }
    .tips {
      font-size: 16px;
      margin: 0 0 24px;
    }
  }
  .el-form-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
  .nextStep-button {
    width: 100%;
    height: 56px;
    font-size: 18px;
    border: 0;
    border-radius: 6px;
    margin: 20px 0 0;
  }
  .form-result {
    margin: 80px 0 0;
    text-align: center;
    .result-icon {
      width: 77px;
      height: 77px;
    }
    .result-desc {
      font-size: 16px;
      line-height: 24px;
      margin: 32px 0 0;
      .link {
        cursor: pointer;
        color: #417ef7;
        text-decoration: underline;
      }
    }
  }
}
</style>
